import { render, staticRenderFns } from "./PaymentPlanDetails.vue?vue&type=template&id=0196f19e&scoped=true&"
import script from "./PaymentPlanDetails.vue?vue&type=script&lang=js&"
export * from "./PaymentPlanDetails.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPlanDetails.vue?vue&type=style&index=0&id=0196f19e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0196f19e",
  null
  
)

export default component.exports